




































































































































































































import { Prop, Component, Mixins } from "vue-property-decorator";
import EstimateItemViewModel from "../presenters/estimate-item-view-model";
import EstimateRow from "./EstimateRow.vue";
import SelectOption from "../../../common/ui/presenters/select-option";
import { EnvironmentMixin } from "@/helpers/environment-mixin";
import Decimal from "decimal.js";
import { ESTIMATE_ITEM_LEVEL } from "@/preferences";

@Component({
  computed: {
    ESTIMATE_ITEM_LEVEL() {
      return ESTIMATE_ITEM_LEVEL;
    }
  },
  components: {
    EstimateRow
  }
})
export default class EstimateItem extends Mixins<EnvironmentMixin>() {
  @Prop({ required: true }) item!: EstimateItemViewModel;
  @Prop({ required: true }) unitOptions!: SelectOption[];
  @Prop({ required: true }) expenseCategoryOptions!: SelectOption[];
  @Prop({ required: true }) level!: number;
  @Prop({ required: true }) isShowNoteColumn!: boolean;
  @Prop({ required: true }) styleGridColumn!: string;
  @Prop({ required: true }) estimateRowSelected!: Set<string>;
  @Prop({ required: true }) profitRateOfEstimate!: number;
  @Prop({ required: false }) isHideVendorColumn?: boolean;
  @Prop({ required: true }) isDiscountRow!: boolean;

  get profitRatePercent(): number {
    if (!this.item.totalPrice || this.item.totalPrice === 0) {
      return 0;
    }
    return Number(
      new Decimal(this.item.totalPrice)
        .minus(this.item.loss)
        .div(this.item.totalPrice)
        .mul(100)
        .toFixed(1)
    );
  }

  profitAmount(item: EstimateItemViewModel): number {
    if (!this.item) {
      return 0;
    }
    return item.totalPrice - item.loss;
  }

  calculate() {
    this.$emit("change");
  }

  isEstimateRowSelected(item: EstimateItemViewModel): boolean {
    if (item.items.length > 0) {
      return item.items.some(subItem => this.isEstimateRowSelected(subItem));
    }
    return this.estimateRowSelected.has(item.id.toString());
  }

  get isChecked(): boolean {
    return this.isEstimateRowSelected(this.item);
  }

  addLowestItemToSet(item: EstimateItemViewModel) {
    if (item.items.length > 0) {
      item.items.forEach(it => this.addLowestItemToSet(it));
    } else {
      this.estimateRowSelected.add(item.id.toString());
    }
  }

  removeLowestItemFromSet(item: EstimateItemViewModel) {
    if (item.items.length > 0) {
      item.items.forEach(it => this.removeLowestItemFromSet(it));
    } else {
      this.estimateRowSelected.delete(item.id.toString());
    }
  }

  handleEstimateRowChecked(isChecked: boolean) {
    isChecked
      ? this.addLowestItemToSet(this.item)
      : this.removeLowestItemFromSet(this.item);
    this.$emit("afterChecked");
  }

  get isWarning(): boolean {
    return (
      this.profitRatePercent !== 0 &&
      this.profitRatePercent < this.profitRateOfEstimate
    );
  }

  isNegative(value: number): boolean {
    return value < 0;
  }
}
